'use strict';

var React = require('react');
var reactNumberFormat = require('react-number-format');
var TextInput = require('../../TextInput/src/TextInput.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const isPatternFormat = (format) => typeof format === 'string';
const NumberInputView = React__namespace.forwardRef((props, ref) => {
    const { format, thousandSeparator, decimalSeparator, decimalScale, fixedDecimalScale, allowNegative = false, allowedDecimalSeparators = [',', '.'], step, ...restProps } = props;
    if (isPatternFormat(format)) {
        return React__namespace.createElement(reactNumberFormat.PatternFormat, { ...restProps, getInputRef: ref, format: format, customInput: TextInput.TextInput });
    }
    return (React__namespace.createElement(reactNumberFormat.NumericFormat, { ...restProps, getInputRef: ref, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, decimalScale: decimalScale, fixedDecimalScale: fixedDecimalScale, allowNegative: allowNegative, allowedDecimalSeparators: allowedDecimalSeparators, customInput: TextInput.TextInput }));
});

exports.NumberInputView = NumberInputView;
//# sourceMappingURL=NumberInputView.js.map
